"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeToUnlockDesignBomSuccess = exports.subscribeToUnlockDesignBom = void 0;
const events_service_types_1 = require("@hip/events-service-types");
const createSubscriber_1 = require("../helpers/createSubscriber");
const subscribeToUnlockDesignBom = (socket, listener) => (0, createSubscriber_1.createSubscriber)(socket, events_service_types_1.UNLOCK_DESIGN_BOM_EVENTS.UNLOCK_DESIGN_BOM, listener);
exports.subscribeToUnlockDesignBom = subscribeToUnlockDesignBom;
const subscribeToUnlockDesignBomSuccess = (socket, listener) => (0, createSubscriber_1.createSubscriber)(socket, events_service_types_1.UNLOCK_DESIGN_BOM_EVENTS.UNLOCK_DESIGN_BOM_SUCCESS, listener);
exports.subscribeToUnlockDesignBomSuccess = subscribeToUnlockDesignBomSuccess;
